/* Fondo 3D de la portada: tela en movimiento, en WebGL escrito a mano.
 *
 * Sin librerias. three.js son ~600 KB para esto; el shader de abajo son 3 KB y
 * corre en la GPU, asi que no pelea con el hilo principal ni con el scroll.
 *
 * Lo que se ve: pliegues de tela avanzando despacio en la paleta beige de la
 * marca, con una luz que sigue al puntero. La profundidad es real: las bandas
 * se desplazan a distintas velocidades segun su capa.
 *
 * Se apaga solo cuando: no hay WebGL, el visitante pide menos movimiento, la
 * pestana esta oculta o la portada no esta en pantalla. Si no arranca, debajo
 * queda la foto y el degradado CSS: nunca un hueco.
 */
(function () {
  'use strict';

  var lienzo = document.querySelector('[data-fv-tela]');
  if (!lienzo) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var gl = lienzo.getContext('webgl', { alpha: true, antialias: false, depth: false })
        || lienzo.getContext('experimental-webgl', { alpha: true, antialias: false, depth: false });
  if (!gl) return;                       // se queda la foto y el degradado

  var VERT = [
    'attribute vec2 p;',
    'void main(){ gl_Position = vec4(p, 0.0, 1.0); }'
  ].join('\n');

  var FRAG = [
    'precision mediump float;',
    'uniform vec2  u_res;',
    'uniform float u_t;',
    'uniform vec2  u_raton;',
    'uniform float u_scroll;',
    '',
    // ruido de valor clasico, barato y suficiente para tela
    'float h(vec2 x){ return fract(sin(dot(x, vec2(12.9898,78.233))) * 43758.5453); }',
    'float ruido(vec2 x){',
    '  vec2 i = floor(x), f = fract(x);',
    '  vec2 u = f*f*(3.0-2.0*f);',
    '  return mix(mix(h(i), h(i+vec2(1.0,0.0)), u.x),',
    '             mix(h(i+vec2(0.0,1.0)), h(i+vec2(1.0,1.0)), u.x), u.y);',
    '}',
    'float fbm(vec2 x){',
    '  float v = 0.0, a = 0.5;',
    '  for(int i = 0; i < 5; i++){ v += a*ruido(x); x *= 2.02; a *= 0.5; }',
    '  return v;',
    '}',
    '',
    'void main(){',
    '  vec2 uv = gl_FragCoord.xy / u_res.xy;',
    '  vec2 q  = uv;',
    '  q.x *= u_res.x / u_res.y;',
    '',
    '  float t = u_t * 0.035 + u_scroll * 0.55;',
    '',
    // tres capas a distinta velocidad: eso es la profundidad
    '  float c1 = fbm(q * 2.10 + vec2(t * 1.00, -t * 0.35) + u_raton * 0.16);',
    '  float c2 = fbm(q * 3.60 + vec2(-t * 0.62, t * 0.48) + u_raton * 0.30);',
    '  float c3 = fbm(q * 6.80 + vec2(t * 0.30,  t * 0.90) + u_raton * 0.46);',
    '',
    // los pliegues salen de doblar el ruido sobre si mismo
    '  float pliegue = abs(sin((c1 * 2.4 + c2 * 1.5) * 3.14159 + t * 0.8));',
    '  float trama   = 0.55 * c1 + 0.30 * c2 + 0.15 * c3;',
    '  float v = mix(trama, pliegue, 0.62);',
    '',
    // paleta de la marca: papel, crema, arena, cafe
    '  vec3 papel = vec3(0.953, 0.929, 0.890);',
    '  vec3 crema = vec3(0.929, 0.898, 0.847);',
    '  vec3 arena = vec3(0.878, 0.831, 0.769);',
    '  vec3 cafe  = vec3(0.725, 0.631, 0.518);',
    '  vec3 col = mix(papel, crema, smoothstep(0.20, 0.55, v));',
    '  col = mix(col, arena, smoothstep(0.48, 0.78, v));',
    '  col = mix(col, cafe,  smoothstep(0.74, 0.98, v) * 0.72);',
    '',
    // luz especular siguiendo al puntero, como la seda al girarla
    '  vec2 luz = vec2(0.5, 0.45) + u_raton * 0.34;',
    '  float d = distance(vec2(uv.x * (u_res.x/u_res.y), uv.y),',
    '                     vec2(luz.x * (u_res.x/u_res.y), luz.y));',
    '  col += (1.0 - smoothstep(0.0, 0.66, d)) * 0.115;',
    '',
    // grano finisimo: sin el, los degradados se ven a bandas
    '  col += (h(gl_FragCoord.xy + u_t) - 0.5) * 0.016;',
    '',
    // se desvanece hacia abajo para casar con el contenido que viene despues
    '  float alfa = smoothstep(0.0, 0.30, uv.y) * 0.42;',
    '  gl_FragColor = vec4(col, alfa);',
    '}'
  ].join('\n');

  function compilar(tipo, src) {
    var s = gl.createShader(tipo);
    gl.shaderSource(s, src);
    gl.compileShader(s);
    return gl.getShaderParameter(s, gl.COMPILE_STATUS) ? s : null;
  }

  var vs = compilar(gl.VERTEX_SHADER, VERT);
  var fs = compilar(gl.FRAGMENT_SHADER, FRAG);
  if (!vs || !fs) return;

  var prog = gl.createProgram();
  gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
  if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;
  gl.useProgram(prog);

  var buf = gl.createBuffer();
  gl.bindBuffer(gl.ARRAY_BUFFER, buf);
  gl.bufferData(gl.ARRAY_BUFFER, new Float32Array([-1,-1, 3,-1, -1,3]), gl.STATIC_DRAW);
  var loc = gl.getAttribLocation(prog, 'p');
  gl.enableVertexAttribArray(loc);
  gl.vertexAttribPointer(loc, 2, gl.FLOAT, false, 0, 0);

  var uRes    = gl.getUniformLocation(prog, 'u_res');
  var uT      = gl.getUniformLocation(prog, 'u_t');
  var uRaton  = gl.getUniformLocation(prog, 'u_raton');
  var uScroll = gl.getUniformLocation(prog, 'u_scroll');

  gl.enable(gl.BLEND);
  gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

  var raton = { x: 0, y: 0 }, suave = { x: 0, y: 0 }, scroll = 0;

  function medir() {
    // se limita a 1.5 para no renderizar 4x pixeles en pantallas retina
    var dpr = Math.min(window.devicePixelRatio || 1, 1.5);
    var w = Math.max(1, Math.round(lienzo.clientWidth  * dpr));
    var h = Math.max(1, Math.round(lienzo.clientHeight * dpr));
    if (lienzo.width !== w || lienzo.height !== h) {
      lienzo.width = w; lienzo.height = h;
      gl.viewport(0, 0, w, h);
    }
  }

  window.addEventListener('resize', medir, { passive: true });
  window.addEventListener('scroll', function () {
    var r = lienzo.getBoundingClientRect();
    scroll = Math.min(1, Math.max(0, -r.top / Math.max(1, r.height)));
  }, { passive: true });

  window.addEventListener('pointermove', function (e) {
    var r = lienzo.getBoundingClientRect();
    raton.x = (e.clientX - r.left) / r.width  - 0.5;
    raton.y = 0.5 - (e.clientY - r.top) / r.height;
  }, { passive: true });

  // no gastar bateria dibujando algo que nadie esta viendo
  var enPantalla = true;
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (es) {
      enPantalla = es[0].isIntersecting;
      if (enPantalla) pintar(performance.now());
    }, { threshold: 0 }).observe(lienzo);
  }

  var t0 = performance.now(), corriendo = false;
  function pintar(ahora) {
    if (corriendo && !enPantalla) { corriendo = false; return; }
    if (document.hidden) { corriendo = false; return; }
    corriendo = true;
    medir();
    // el puntero se persigue con retardo: el movimiento queda liquido, no nervioso
    suave.x += (raton.x - suave.x) * 0.045;
    suave.y += (raton.y - suave.y) * 0.045;
    gl.uniform2f(uRes, lienzo.width, lienzo.height);
    gl.uniform1f(uT, (ahora - t0) / 1000);
    gl.uniform2f(uRaton, suave.x, suave.y);
    gl.uniform1f(uScroll, scroll);
    gl.drawArrays(gl.TRIANGLES, 0, 3);
    requestAnimationFrame(pintar);
  }

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && enPantalla && !corriendo) pintar(performance.now());
  });

  lienzo.classList.add('es-vivo');
  medir();
  requestAnimationFrame(pintar);
})();
